const config = {
	// api_url: "https://api.altexchange.com/",
	appName: "Teleplay",
	api_url: "https://php.picpulseai.com/greenscreen/public/service.php",
	// api_url: "http://localhost/public/service.php",
}

export default config;